import {Component, inject} from '@angular/core';
import {PrimeNgImportsModule} from '../../../../sdk/src/prime-ng-imports';
import {IBasePageComponent} from '../../../../sdk/src/components/ibase-page/ibase-page.component';
import {CpmCOrganizationApiModel} from '../../../../gen/cpm-c-api-ts/src/models/c-customer/cpmc-organization.api-model';
import {ActivatedRoute} from '@angular/router';
import {Subject} from 'rxjs';
import {ObjectStoreEntryCRUDComponent} from '../../components/object-store-entry-crud/object-store-entry-crud.component';
import {OrganizationGeneralInfoComponent} from '../../components/organization/organization-general-info/organization-general-info.component';
import {ServiceRequestCRUDComponent} from '../../components/service-request/service-request-crud/service-request-crud.component';
import {OrganizationHierarchyComponent} from '../../components/organization/organization-hierarchy/organization-hierarchy.component';
import {UserFileCRUDComponent} from '../../components/user-file-crud/user-file-crud.component';

export enum EOrganizationTab {
    GENERAL = 'general',
    SERVICE_REQUESTS = 'service-requests',
    HIERARCHY = 'hierarchy',
    OBJECT_STORE = 'object-store',
    FILES = 'files'
}

@Component({
    selector: 'app-co-overview-page',
    templateUrl: './co-overview-page.component.html',
    imports: [
        PrimeNgImportsModule,
        ObjectStoreEntryCRUDComponent,
        OrganizationGeneralInfoComponent,
        ServiceRequestCRUDComponent,
        OrganizationHierarchyComponent,
        UserFileCRUDComponent
    ]
})
export class COOverviewPageComponent extends IBasePageComponent {
    private readonly activatedRoute = inject(ActivatedRoute);
    private _currentTabBackingField = EOrganizationTab.GENERAL;

    // ===============================================================
    // ===============================================================

    protected readonly EOrganizationTab = EOrganizationTab;
    protected organization: CpmCOrganizationApiModel | undefined;
    protected refreshStatistics$ = new Subject<void>();

    protected get currentTab(): EOrganizationTab {
        return this._currentTabBackingField;
    }
    protected set currentTab(value: EOrganizationTab) {
        this._currentTabBackingField = value;
        this.globalsService.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: {tab: value},
            queryParamsHandling: 'merge',
            replaceUrl: true,
            skipLocationChange: false
        });
    }

    // ===============================================================
    // ===============================================================

    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    protected override async onReady(): Promise<void> {
        await this.globalsService.sessionService.getRouteContextIsReadyPromise();

        let tab = this.activatedRoute.snapshot.queryParams['tab'];
        if (this.activatedRoute.snapshot.data['tab']) tab = this.activatedRoute.snapshot.data['tab'];

        this._currentTabBackingField = Object.values(EOrganizationTab).includes(tab as EOrganizationTab)
            ? (tab as EOrganizationTab)
            : EOrganizationTab.GENERAL;

        this.organization = this.globalsService.sessionService.getOrganization();
    }
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}

    // ===============================================================
    // ===============================================================

    /**
     * Handle organization updated event from child component
     */
    protected onOrganizationUpdated(): void {
        // Refetch organization from session service to trigger change detection
        this.organization = this.globalsService.sessionService.getOrganization();
    }
}
